import cx from 'classnames';
import styles from './index.module.css';

/**
 * @typedef {"absolute" | "relative" | "fixed" | "sticky"} position
 *
 * @param position {position}
 * @returns - [className]
 *
 * @example
 * const [positionClassName] = getPosition('absolute');
 */
const getPosition = position => [cx({
  [styles.positionAbsolute]: position === 'absolute',
  [styles.positionRelative]: position === 'relative',
  [styles.positionFixed]: position === 'fixed',
  [styles.positionSticky]: position === 'sticky'
})];
export default getPosition;